import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateVehicleTypeComponent = loadable(
  () => import("../../components/VehicleType/CreateVehicleType")
);
const CreateVehicleType = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["vehicle-type"],
    navigateURL: "/vehicle-type",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.VEHILCE_TYPE}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Vehicle Type
        </span>
      </div>
      <CreateVehicleTypeComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateVehicleType;
